import React from "react";

const ProjectMessageTemplate = () => (
  <section className="messageTemplate">
    <p>
      Below is the template for Email being sent from the Projects Listing page.
    </p>
    <b>Dear Sir/Ma'am,</b>
    <br />
    <p className="message">
      <br />
      <i>
        The message that you would enter in the message box will be reflected
        here.
      </i>
    </p>
    <br />
    Project(s) List:
    <ul>
      <li>#{`<ProjectID>: <ProjectTitle>`}</li>
      <li>#{`<ProjectID>: <ProjectTitle>`}</li>
    </ul>
    <p>For any queries, please write to pmg@investindia.org.in.</p>
    <p>
      Warm Regards,
      <br />
      PMG Team
      <br />
      https://pmg.dpiit.gov.in
    </p>
  </section>
);

export { ProjectMessageTemplate };
